import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Where the Stripe page for a phone booking sends the customer after paying. No sign-in needed.
export default function ThankYou() {
  const cancelled = new URLSearchParams(useLocation().search).get('cancelled');
  return (
    <main className="min-h-screen bg-[#0d0e11] text-gray-50 flex items-center justify-center px-6" data-testid="thank-you">
      <div className="max-w-md text-center space-y-5">
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">{cancelled ? 'Payment not completed' : 'Thank you'}</h1>
        <p className="text-base text-gray-300 leading-relaxed">{cancelled ? 'No payment was taken and no ride was booked. Use the same link again, or contact RideBuraq to book by phone.' : 'Your payment is received. Your ride is confirmed, and we will send the details to you by email (and by text if you agreed to texts).'}</p>
        <Link to="/" className="inline-flex items-center justify-center px-6 h-12 rounded-full text-base border border-white/25 text-gray-100 hover:border-white/60 hover:bg-white/[0.06]">Back to RideBuraq</Link>
      </div>
    </main>
  );
}
